module.exports = __webpack_public_path__ + "img/icon-07-subscriptionAsset 13.bf13b5d0.svg";